import Vue       from "vue";
import Constants from "./Constants";
import _         from "lodash";
import moment    from "moment";
import {load}    from "recaptcha-v3";

/**
 * 預設 Vuejs app 在 created 裡面要做的設定
 * @param app
 */
export function defaultOnCreated(app) {

    // ----------------------------------------------------------
    //                      Moment 語言設定
    // ----------------------------------------------------------
    if (app.getMetaContent('locale') === 'tw') {
        app.$moment.locale('zh-tw');
    }

    // ----------------------------------------------------------
    //                     全域 Axios 錯誤設定
    // ----------------------------------------------------------
    Vue.prototype.$http.interceptors.response.use(function (response) {
        // 成功時, 不做任何處理
        return response;
    }, function (error) {
        app.showResponseError(error);
        return Promise.reject(error);
    });

    // ----------------------------------------------------------
    //      畫面點擊任何地方，不是點在 Dialog 上的話，要關閉視窗
    // ----------------------------------------------------------
    $('body').on('click', '.rd_dialog', function(e) {
        // 點擊在 Dialog 主視窗外面， 關閉視窗
        if ($(e.target).hasClass('rd_dialog_outside')) {
            app.showLoading   = false;   // 顯示/隱藏 Loading Dialog
            app.$refs.msgDialog.hideDialog();
        }
    });
} // end of function 

/**
 * 找到 & 回傳給予的 meta 名稱中的值
 * @param metaName
 * @returns {string|null}
 */
export function getMetaContent(metaName) {
    const metas = document.getElementsByTagName('meta');
    for (let i = 0; i < metas.length; i++) {
        if (metas[i].getAttribute('name') === metaName) {
            return metas[i].getAttribute('content');
        }
    }
    return null;
} // end of function 

/**
 * 每一個 Framework 的 response 的 root 路徑都不太一樣
 * @param response
 * @returns {*}
 */
export function extractResponseData(response) {
    return response.data.Value;
} // end of function 

/**
 * 將給予的路徑前面加上 完整的 server 網址
 *
 * @param target 如果是 string, 直接當成 網址使用, 如果是物件 & 有給 property, 會使用 _.get() 取回
 * @param property
 * @returns {string|null}
 */
export function prefixServerRootUrl(target, property) {
    let parts = null;

    // 如果給予的 parts 不是 null， 製作相對應網址
    if (_.isString(target)) {
        parts = target;
    } else if (!_.isString(target) && _.isString(property)) {
        parts = _.get(target, property, null);
    } // end of if

    if (parts) {
        if (_.startsWith(parts,'/')) {
            return `${Constants.serverRoot}${parts}`;
        } else {
            return `${Constants.serverRoot}/${parts}`;
        } // end of if
    } // end of if

    return null;
}

const mixin = {
    data: function () {
        return {
            showMainMenu: false,                           // 顯示/隱藏 主 Menu
            showLoading : false,                           // 顯示/隱藏 Loading Dialog
            
            pageData: {},
            
        }
    },
    mounted() {
        $(window).scroll(function() {
            if ($(this).scrollTop() > 200) {
                $('.rdgotop').fadeIn(200);
            } else {
                $('.rdgotop').fadeOut(200);
            }
        });
    },
    methods: {
        getMetaContent,
        extractResponseData,
        prefixServerRootUrl,
        /**
         * 顯示 Message Dialog
         */
        showMessage(setting, count = 0) {
            // import Dialog 時 有可能因為 Component 還沒實際 load 進來
            // 導致 this.$refs.msgDialog 是 null/undefined, 因此如果發現 
            // dialog 是 null 時， 等待 0.2 秒後 再敲一次自己
            if (count > 10) {
                return;
            } // end of if
            
            let dialog = this.$refs.msgDialog;
            
            if (dialog) {
                dialog.showDialog(setting);
            } else {
                let self = this;
                setTimeout(() => {
                    self.showMessage(setting, count + 1);
                }, 200)
            }
        },
        /**
         * 隱藏 Message Dialog
         */
        hideMessage() {
            this.$refs.msgDialog.hideDialog();
        },
        /**
         * 隱藏 Loading Dialog
         */
        showResponseError(error, title) {
            // 顯示錯誤視窗
            try {
                // 判斷是否已被登出 - .Net 會回傳 404
                let returnUrl = self._.get(error, 'request.responseURL', '') || '';

                if (returnUrl.indexOf('/auth/denied') !== -1) {
                    this.showMessage({ config: { msg: '畫面閒置過久，請重新登入。', title: title } });
                } else {
                    if (error.response.status === 404) {
                        this.showMessage({ config: { msg: '查無此資訊。', title: title } });
                    } else if (error.response.status === 401) {
                        this.showMessage({ config: { msg: '畫面閒置過久，請重新登入。', title: title } });
                    } else {
                        this.showMessage({ config: { msg: 'An error occurred, please re-arrange the page and try again.', title: title } });
                    }
                } // end of if
            } catch (e) {

            } // end of try-catch
        },
        retrieveSiteContentData(onComplete = null) {
            // 開啟 Loading dialog
            this.showLoading = true;

            // 製作跟目前頁面相對應的 template 路由 (把 http://xxx.xxx.xxx/路徑/路徑/路徑 改成 http://xxx.xxx.xxx/api/路徑/路徑/路徑 )
            let self          = this;
            let dataUrl       = window.location.href.replace(`${Constants.serverUrl}`, `${Constants.serverUrl}/api`);

            this.$http.get(dataUrl)
                .then(function(response) {
                    // 成功取回資料後, 將資料儲存到 Vuex 中
                    let responseData = self.extractResponseData(response);
                    let pageData     = _.get(responseData, 'pageData');

                    self.$set(self, 'pageData', pageData);

                    // 開啟 關閉 Loading Dialog
                    self.showLoading = false;

                    if (onComplete) {
                        onComplete(response);
                    }
                }).catch(function (error) {

                // 開啟 關閉 Loading Dialog
                self.showLoading = false;

                // 顯示預設錯誤訊息
                self.showResponseError(error, 'Retrieve Template');
            });
        },

        fetchNormalData(url, dataPath, responsePath = 'pageData.contentData', onComplete = null, showLoading = false){
            let self = this;

            // 開啟 Loading dialog
            this.showLoading = showLoading;

            this.$http.get(url, { params: _.get(self.contentData, dataPath, {}) })
                .then(function(response) {
                    
                    // 關閉 Loading dialog
                    self.showLoading = false;

                    // Callback
                    if (onComplete != null) {
                        onComplete(response);
                    } // end of if

                }).catch(function (error) {
                // 關閉 Loading dialog
                self.showLoading = false;

                // 顯示預設錯誤訊息
                self.showResponseError(error);
            });
        },
        /**
         * 取回資料 (GET)
         * @param url url
         * @param dataPath 會用 _.get(contentData, [給的 dataPath]) 的方式， 把資料送到 Server
         * @param saveTo 會用 _.set(contentData, [給的 saveTo], [回傳結果]) 的方式， 把取回的資料放到 contentData 中的路徑
         * @param responsePath 會用 _.get(responseData, [給的 responsePath]) 的方式， 把資料取出
         * @param onComplete onComplete callback
         * @param extraParams onComplete callback 時，會再將 extraParams 丟回去給 user
         * @param showLoading 是否要顯示 loading 
         */
        fetchData(url, dataPath, saveTo, responsePath = 'pageData.contentData', onComplete = null, extraParams = null, showLoading = false) {
            let self = this;

            // 開啟 Loading dialog
            this.showLoading = showLoading;

            this.$http.get(url, { params: _.get(self.contentData, dataPath, {}) })
                .then(function(response) {

                    // 成功取回資料後, 將資料儲存到 Vuex 中
                    let retrieved  = self.extractResponseData(response);
                    
                    let wantedData =  _.get(retrieved, responsePath);

                    self.$set(self.contentData, saveTo, wantedData);
                    
                    // 關閉 Loading dialog
                    self.showLoading = false;

                    // Callback
                    if (onComplete != null) {
                        onComplete(extraParams, response);
                    } // end of if

                }).catch(function (error) {
                // 關閉 Loading dialog
                self.showLoading = false;

                // 顯示預設錯誤訊息
                self.showResponseError(error);
            });
        },
        /**
         * 發送資料 (POST)
         * @param url url
         * @param dataPath 會用 _.get(contentData, [給的 dataPath]) 的方式， 把資料送到 Server
         * @param saveTo 會用 _.set(contentData, [給的 saveTo], [回傳結果]) 的方式， 把取回的資料放到 contentData 中的路徑
         * @param responsePath 會用 _.get(responseData, [給的 responsePath]) 的方式， 把資料取出
         * @param onComplete onComplete callback
         * @param extraParams onComplete callback 時，會再將 extraParams 丟回去給 user
         * @param showLoading 是否要顯示 loading
         */
        postData(url, dataPath, saveTo = null, responsePath = 'pageData.contentData', onComplete = null, extraParams = null, showLoading = true) {
            let self = this;

            // 開啟 Loading dialog
            this.showLoading = showLoading;

            let dataToPost = _.get(self.contentData, dataPath, {});
            let formData   = this.convertToFormData(dataToPost);              // 使用 Utils function 將 json 轉成 formData
            
            this.$http.post(url, formData)
                .then(function(response) {

                    // 成功取回資料後, 將資料儲存到 Vuex 中
                    if (saveTo != null) {
                        let retrieved  = self.extractResponseData(response);
                        let wantedData = _.get(retrieved, responsePath);
                        _.set(self.contentData, saveTo, wantedData);
                        // self.$set(self.pageData, 'contentData', self.contentData);
                        self.$set(self.pageData, 'contentData', self.contentData);
                    } // end of if

                    // 關閉 Loading dialog
                    self.showLoading = false;
                    
                    // Callback
                    if (onComplete != null) {
                        onComplete(extraParams, response);
                    } // end of if

                }).catch(function (error) {
                // 關閉 Loading dialog
                self.showLoading = false;

                // 顯示預設錯誤訊息
                self.showResponseError(error);
            });
        },
        validate(successCallback) {
            let self           = this;
            let config         = { ignore: [] };
            let scrollIntoView = { behavior: 'smooth', block: 'center' };

            let handleResult = function(isValid) {

                if (isValid) {
                    successCallback();
                } else {

                    // 取回 validate 失敗的 VueComponent 物件
                    let invalids = _.map(_.filter(self.$refs.observer.fields, 'invalid'), 'id');
                    let matches  = _.pickBy(self.$refs.observer.refs, function(value, key) {
                        return invalids.includes(key);
                    });

                    // 捲動到第一個錯誤
                    if (scrollIntoView !== false) {
                        // matches 是一個物件, 然後欄位名稱是 dom 的名字 (invalids) (Validate 的錯誤物件有點詭異)
                        // {  
                        //    "大標題 86c9c950-de60-11eb-874c-a161374e5cb1": VueComponent,
                        //    "大標題 8b3d9e30-de60-11eb-874c-a161374e5cb1": VueComponent,
                        //    ....
                        // }
                        let target = _.get(matches, invalids[0]).$el;

                        // 只有 'true', 沒有設定
                        if (scrollIntoView === true) {
                            target.scrollIntoView();
                        } else {
                            target.scrollIntoView(scrollIntoView);
                        } // end of if
                    } // end of if

                    // 將找到的 VueComponent 放到 'invalidFields' property 中
                    _.set(self.$refs.observer, 'invalidFields', matches);

                    // 取回 validate 失敗的 VueComponent 物件, 有被 '.r-validate-container' 包覆著, 加上一個 'r-validate-container-error' 的 css class
                    _.each(matches, function(component) {
                        let container = component.$el.closest('.r-validate-container');
                        if (container != null) {
                            container.classList.add('r-validate-container-error');
                        } // end of if
                    });
                }

            };

            // 清除之前的錯誤
            self.$refs.observer.reset();

            // 判斷是否有錯
            self.$refs.observer.validate(config).then((isValid) => handleResult(isValid) );
        },
        convertToFormData(json, form = null, ignoreList = []) {
            let formData = form || new FormData();

            function appendFormData(data, prefix) {
                let shallIgnore = Array.isArray(ignoreList) && ignoreList.some(function(x) { return x === prefix; });

                if (!shallIgnore) {
                    // 檔案
                    if (data instanceof File) {
                        formData.append(prefix, data);
                    }
                    // array
                    else if (Array.isArray(data)) {
                        // 需要檢查內容物，如果是物件，需要加上 [index]
                        let isObject = data.length > 0 ? _.isObject(data[0]) : false;

                        for (let i = 0; i < data.length; i++) {
                            if (isObject) {
                                appendFormData(data[i], `${prefix}[${i}]`);
                            } else {
                                appendFormData(data[i], prefix);
                            }
                        }
                    }
                    // 物件
                    else if (_.isObject(data)) {
                        for (let key in data) {
                            if (data.hasOwnProperty(key)) {
                                if (prefix === '') {
                                    appendFormData(data[key], key);
                                } else {
                                    appendFormData(data[key], `${prefix}_${key}`);
                                }
                            }
                        }
                    }
                    // 其他: string, int, float, ...
                    else {
                        if (data !== null && typeof data !== 'undefined') {
                            formData.append(prefix, data);
                        } else {
                            formData.append(prefix, '');
                        }
                    }
                }
            }

            appendFormData(json, '');

            return formData;
        },
        log(msg) {
            console.log(msg);
        },
        showDate(dateString, locale = null, format = "MMM DD, YYYY") {
            let date = moment(dateString);
            date.locale('en')
            if (locale) {
                date.locale(locale)
            }
            return date.format(format)
        },
        shareMedia(type){
            let url = location.href
            switch(type){
                case "fb":
                    window.open('http://www.facebook.com/share.php?u='.concat(encodeURIComponent(url)))
                    break;
                case "tr":
                    window.open('https://twitter.com/intent/tweet?original_referer='+encodeURIComponent(url)+'&url='+encodeURIComponent(url))
                    break;
                case "line":
                    window.open('https://social-plugins.line.me/lineit/share?url='+encodeURIComponent(url))
                    break;
            } 
        },
        goTop(){
            $('html, body').animate({scrollTop: 0}, 300);
        },
        goToUrl(link){
            if(!_.isEmpty(link)){
                window.open(link) 
            }
        },
        loadToken(self, action) {
            load(Constants.recaptchaSiteKey,{renderParameters:{hl:'en'}}).then((recaptcha) => {
                recaptcha.execute(action).then((token) => {
                    self.token = token
                })
            })
        }
    }, // end of methods,
    computed: {
        contentData: {
            get() {
                return _.get(this.pageData, 'contentData', {}) || {};
            },
            set(val) {
                this.pageData.contentData = val;
            }
        },
        form() {
            return _.get(this.pageData, 'contentData.form', {}) || {};
        },
    }, // end of computed
    watch: {
        pageData: {
            handler: (val) => {},
            deep: true,
        },
        "pageData.contentData": {
            handler: (val) => {},
            deep: true,
        }
    } // end of watch

};

export default mixin;